<template>
    <div>
        <span>{{ $t('notification.webAppUpdated', {
            actor: $_.get(activity, 'actorUser.name'),
            appName: $_.get(activity, 'payload.appName'),
            appSlug: $_.get(activity, 'payload.appSlug')
        }) }}</span>
    </div>
</template>

<script>
export default {
    name: "WebAppUpdated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    }
};
</script>


